import { render, staticRenderFns } from "./PasswordText.vue?vue&type=template&id=5b641432&"
import script from "./PasswordText.vue?vue&type=script&lang=js&"
export * from "./PasswordText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports